(() => {
  if (!document.body.classList.contains('template-product')) return;

  const section = document.querySelector('[data-section-type="product"]');
  const bar = section?.querySelector('[data-mobile-buy-bar]');
  if (!section) return;

  const rerender = section.querySelector('product-rerender');
  let gallery = null;
  let galleryObserver = null;
  let observedButton = null;
  let scheduled = false;

  const buttonObserver = new IntersectionObserver((entries) => {
    if (!bar) return;
    bar.classList.toggle('is-visible', !entries[0].isIntersecting);
  }, { threshold: 0.15 });

  const readablePrice = (element) => {
    if (!element) return '';
    const copy = element.cloneNode(true);
    copy.querySelectorAll('.visually-hidden').forEach((node) => node.remove());
    const price = copy.textContent.trim().replace(/\s+/g, ' ');
    if (bar?.dataset.localCountry === 'ZA' && bar.dataset.localCurrency === 'ZAR') {
      return price.replace(/^R\s*/, 'R').replace(/\.00$/, '');
    }
    return price;
  };

  const updateCount = () => {
    const count = section.querySelector('[data-mobile-gallery-count]');
    if (!count || !gallery) return;
    const slides = [...gallery.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)')];
    const selected = gallery.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');
    const position = Math.max(1, slides.indexOf(selected) + 1);
    const value = `${position} / ${slides.length}`;
    if (count.textContent !== value) count.textContent = value;
    count.setAttribute('aria-label', `Product image ${position} of ${slides.length}`);
  };

  const visibleSlides = (carousel) => (carousel ? [...carousel.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)')] : []);

  const updateArrows = () => {
    section.querySelectorAll('.product-gallery').forEach((productGallery) => {
      const hide = visibleSlides(productGallery.querySelector('.product-gallery__carousel')).length < 2;
      productGallery.querySelectorAll('[data-gallery-arrow]').forEach((arrow) => {
        if (arrow.hidden !== hide) arrow.hidden = hide;
      });
    });
  };

  // Arrows drive the theme's own thumbnail handler, so Flickity, zoom and the
  // variant image filter stay in charge of which slide is shown.
  section.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-gallery-arrow]');
    const productGallery = arrow?.closest('.product-gallery');
    const carousel = productGallery?.querySelector('.product-gallery__carousel');
    const slides = visibleSlides(carousel);
    if (slides.length < 2) return;
    const selected = carousel.querySelector('.product-gallery__carousel-item.is-selected:not(.is-filtered)');
    const index = Math.max(0, slides.indexOf(selected));
    const step = arrow.dataset.galleryArrow === 'prev' ? -1 : 1;
    const target = slides[(index + step + slides.length) % slides.length];
    productGallery.querySelector(`.product-gallery__thumbnail[data-media-id="${target.dataset.mediaId}"]`)?.click();
  });

  const sync = () => {
    const currentGallery = rerender?.querySelector('.product-gallery__carousel');
    if (currentGallery !== gallery) {
      galleryObserver?.disconnect();
      gallery = currentGallery;
      if (gallery) {
        galleryObserver = new MutationObserver(() => { updateCount(); updateArrows(); });
        galleryObserver.observe(gallery, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
      }
    }
    updateCount();
    updateArrows();

    if (!bar) return;
    const form = document.getElementById(bar.dataset.productForm);
    const sourceButton = form?.querySelector('.product-form__payment-container .product-form__add-button');
    if (sourceButton !== observedButton) {
      buttonObserver.disconnect();
      observedButton = sourceButton;
      if (sourceButton) buttonObserver.observe(sourceButton);
      else bar.classList.remove('is-visible');
    }

    const targetButton = bar.querySelector('[data-mobile-buy-button]');
    if (sourceButton && targetButton) {
      targetButton.disabled = sourceButton.disabled;
      const label = sourceButton.textContent.trim();
      if (targetButton.textContent.trim() !== label) targetButton.textContent = label;
    }

    const price = readablePrice(form?.querySelector('.product-form__info-list .price-list > .price'));
    const priceTarget = bar.querySelector('[data-mobile-buy-price]');
    if (price && priceTarget && priceTarget.textContent !== price) priceTarget.textContent = price;
  };

  const scheduleSync = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      sync();
    });
  };

  bar?.querySelector('[data-mobile-buy-button]')?.addEventListener('click', () => {
    if (bar.querySelector('[data-mobile-buy-button]').disabled) return;
    document.getElementById(bar.dataset.productForm)
      ?.querySelector('.product-form__payment-container .product-form__add-button:not([disabled])')
      ?.click();
  });

  const productForm = bar && document.getElementById(bar.dataset.productForm);
  productForm?.addEventListener('variant:changed', scheduleSync);
  productForm?.addEventListener('product:rerender', scheduleSync);
  if (rerender) new MutationObserver(scheduleSync).observe(rerender, { childList: true, subtree: true });
  sync();
})();
